export default `
  query getOrgUsage($orgId: ID!, $from: String!, $to: String!, $nextToken: String) {
    getOrgUsage(orgId: $orgId, from: $from, to: $to, nextToken: $nextToken) {
      items {
        id
        model
        provider
        useCase
        projectId
        userId
        promptTokens
        completionTokens
        totalTokens
        estCost
        status
        timestamp
        day
      }
      nextToken
    }
  }
`
